var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.407 0.336868C13.9579 -0.112289 13.2297 -0.112289 12.7806 0.336868L7.3719 5.74562L1.96317 0.336868C1.51407 -0.112289 0.785934 -0.112289 0.336823 0.336868C-0.112274 0.785965 -0.112274 1.51411 0.336823 1.96321L5.74556 7.37196L0.336823 12.7807C-0.112274 13.2298 -0.112274 13.9579 0.336823 14.407C0.785934 14.8561 1.51407 14.8561 1.96318 14.407L7.3719 8.99831L12.7806 14.407C13.2297 14.8561 13.9579 14.8561 14.407 14.407C14.8561 13.9579 14.8561 13.2298 14.407 12.7807L8.99825 7.37196L14.407 1.96321C14.8561 1.51411 14.8561 0.785965 14.407 0.336868Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.b7f8bf2efa05718750a82af43d72e45f.svg";
export { ForwardRef as ReactComponent };